import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SwiperModule } from 'swiper/angular';

import { TranslateModule } from '@ngx-translate/core';

// import { HomeComponent } from './pages/home/home.component';
// import { HomeService } from './pages/home/home.service';
import { HeaderComponent } from './components/header/header.component';
import { HomeSwiperComponent } from './components/home-swiper/home-swiper.component';
import { GamesComponent } from './components/games/games.component';
import { RunningMessageComponent } from './components/running-message/running-message.component';
// import { SubHeaderComponent } from './components/sub-header/sub-header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ContentsRoutingModule } from './contents-routing.module';
import { ContentsComponent } from './contents.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LandingPageService } from './pages/landing-page/landing-page.service';
import { MaterialModule, PrimengModule } from '../shared/modules';
import { LoginComponent } from './components/dialog/login/login.component';
import { LogInfoComponent } from './components/log-info/log-info.component';
import { ChangePasswordComponent } from './components/dialog/change-password/change-password.component';
import { ReportComponent as ReportDialogComponent } from './components/dialog/report/report.component';
import { DecimalFormatPipe } from './../pipes/decimal-format.pipe';
import { ReportComponent } from './pages/report/report.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { LoadingPageComponent } from './pages/loading-page/loading-page.component';
import { GameLobbyComponent } from './pages/game-lobby/game-lobby.component';

@NgModule({
  declarations: [
    ContentsComponent,
    LandingPageComponent,
    HeaderComponent,
    FooterComponent,
    HomeSwiperComponent,
    GamesComponent,
    RunningMessageComponent,
    LoginComponent,
    LogInfoComponent,
    ChangePasswordComponent,
    ReportDialogComponent,
    DecimalFormatPipe,
    ReportComponent,
    NotFoundComponent,
    LoadingPageComponent,
    GameLobbyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ContentsRoutingModule,
    SwiperModule,
    MaterialModule,
    PrimengModule,
    TranslateModule
  ],
  providers: [LandingPageService]
})
export class ContentsModule {}
